<ng-select
  [attr.id]="inputId || null"
  class="form-control"
  [items]="items"
  bindLabel="nome"
  bindValue="id"
  [searchable]="searchable"
  [clearable]="clearable"
  [virtualScroll]="virtualScroll"
  [minTermLength]="minTermLength"
  [typeahead]="search$"
  [loading]="loading"
  [notFoundText]="notFoundText"
  [loadingText]="loadingText"
  [compareWith]="compareById"
  [ngModel]="value"
  [disabled]="isDisabled"
  (ngModelChange)="onValueChange($event)"
  (blur)="onTouched()"
  [attr.aria-label]="ariaLabel"
>
</ng-select>
